var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProbioticName } from '@marketing/content';
import MenuItemList from '../../MenuItemList';
import ProductList from '../ProductList';
function OtherProducts(_a) {
    var content = _a.content;
    var treats = content.treats, probiotics = content.probiotics, topSellers = content.topSellers;
    var probioticsForDisplay = [
        __assign(__assign({}, probiotics.find(function (_a) {
            var slug = _a.slug;
            return slug === ProbioticName.FullSpectrum;
        })), { displayName: 'Full Spectrum' }),
        __assign(__assign({}, probiotics.find(function (_a) {
            var slug = _a.slug;
            return slug === ProbioticName.GITargeted;
        })), { displayName: 'GI-Targeted' }),
    ];
    return (_jsxs("div", __assign({ className: "flex justify-start items-start h-full w-full gap-xl-gutter" }, { children: [_jsxs("div", __assign({ className: "flex justify-start items-start gap-sm-gutter shrink-0" }, { children: [_jsx(MenuItemList, { maxHeight: "100%", columnWidth: "auto", title: "Treats", menuItems: treats }), _jsx(MenuItemList, { maxHeight: "100%", columnWidth: "auto", title: "Probiotics", menuItems: probioticsForDisplay })] })), _jsx(ProductList, { title: "Top Sellers", products: topSellers, viewAllUrl: "/other-products" })] })));
}
export default OtherProducts;
